<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          New Claims Advice - Send Email
        </h1>
      </template>
      <template #actions>
        <page-header-action @click.prevent="toggleNotes">
          Notes
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-12">
        <form-navigation-tabs
          :tabs="tabs"
          v-on:selected="setActive"
          :simple="true"
          :active="currentView"
        ></form-navigation-tabs>
      </div>
    </div>
    <div v-show="currentView == 'new_claims_advice'">
      <div class="row">
        <div class="col-lg-12">
          <div class="card mb-3">
            <div class="card-body">
              <div class="alert alert-info text-center">
                <p class="mb-0">Please comma separate email addresses</p>
              </div>
              <inputbox
                name="to"
                label="To"
                v-model="form.to"
                :show-error="form.errors.has('to')"
                :error-message="form.errors.get('to')"
              ></inputbox>
              <inputbox name="cc" label="CC" v-model="form.cc"></inputbox>
              <inputbox
                name="subject"
                label="Subject"
                v-model="form.subject"
                :show-error="form.errors.has('subject')"
                :error-message="form.errors.get('subject')"
              ></inputbox>
              <input-block
                name="body"
                label="Message"
                v-model="form.body"
                :show-error="form.errors.has('body')"
                :error-message="form.errors.get('body')"
              ></input-block>
            </div>
            <div class="card-footer text-right">
              <form-button
                :indicator="form.processing()"
                v-on:clicked="sendNewClaimsAdviceDocument"
                >Send New Claims Advice Document</form-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <incident-details
      :incident="incident"
      v-show="currentView == 'incident_details'"
    ></incident-details>
    <notes-window
      :show="notes"
      :incident="incident"
      v-on:toggle-note="toggleNotes"
    ></notes-window>
  </div>
</template>

<script>
import Notes from './../Shared/Notes.vue';
import IncidentDetails from './../Shared/IncidentDetails.vue';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader,
    PageHeaderAction,
    'notes-window': Notes,
    'incident-details': IncidentDetails
  },

  data() {
    return {
      notes: false,
      currentView: 'new_claims_advice',
      tabs: [
        {
          name: 'new_claims_advice',
          label: 'New Claims Advice - Send Email'
        },
        {
          name: 'incident_details',
          label: 'Incident Details'
        }
      ],
      form: new window.Form({
        to: null,
        cc: null,
        subject: 'New Claims Advice',
        body:
          'Dear Sir/Madam, \n\nPlease find attached the new claims advice document for our client.'
      })
    };
  },

  mounted() {
    this.getThirdParty();
  },

  methods: {
    sendNewClaimsAdviceDocument() {
      this.form
        .post(`/new-claims-advice/${this.incident}/email`)
        .then(response => {
          this.proceedToHireMonitoring();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was an issue, please try again'
          );
        });
    },

    proceedToHireMonitoring() {
      window.Ajax.post('/new-claims-advice/' + this.incident)
        .then(response => {
          window.toastify.success(
            'Success',
            'The new claims advice document was sent successfully!'
          );

          this.$router.push('/claim-monitoring');
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an issue moving the claim to Hire Monitoring'
          );
        });
    },

    getThirdParty() {
      window.Ajax.get(`/incidents/${this.incident}/third-parties`)
        .then(response => {
          if (
            response.data.length > 0 &&
            response.data[0].insurer &&
            response.data[0].insurer.email
          ) {
            this.form.to = response.data[0].insurer.email;
          }
        })
        .catch(error => {});
    },

    toggleNotes() {
      this.notes = !this.notes;
    },
    setActive(tab) {
      this.currentView = tab;
    }
  }
};
</script>
